import { createApp } from "vue";
import App from "./App.vue";

require("./assets/styles/simplest-grid-cv.css");

createApp(App).mount("#app");
